import React from 'react';

function primaryOutlineButton(props){
	return(
		<button type="button" className={"btn btn-outline-primary e-primary-otln-btn " + props.className} onClick={props.handleClick}>{props.name}</button>
	)
}

export default primaryOutlineButton;
